module.exports = "https://syscdn.233leyuan.com/fw/activemodal/1625144333412/static/img/title-signIn-success.de29404c.png";